// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 745) return "static/chunks/745-c521c1d1b2a1a036.js";
	if (chunkId === 7316) return "static/chunks/7316-7df56b4b1592aa4e.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"991":"52774a7f","2761":"8acff102","8445":"bc98253f"}[chunkId] || chunkId) + "." + {"991":"f19c8a81133574c4","1411":"e54ccaad763cfb6c","2761":"14bf814455998f25","5203":"15c8f4a1a535e406","7166":"e9e773d6cb1b15c5","7602":"79ee8b41743a8e15","7621":"4d70b0f3d4cbec48","8445":"de7da7641af40e5d"}[chunkId] + ".js";
};